import React, { useEffect, useState } from "react";
import cx from "classnames";
import styles from "./VideosThumbnail.module.css";
import Image from "next/image";
import LazyLoad from "react-lazy-load";
import Link from "next/link";
import styles2 from "../../NewsCompo/Loading/NewsThumbNailLoadingSkeleton/NewsThumbNailLoadingSkeleton.module.css";
import Skeleton from "@mui/material/Skeleton";

import { jDateFormatter as formatedDate } from "../../../lib/dateFormater";
import { useInView } from "framer-motion";
import { imageBase64 } from "../../Data/blureBase64Image";

const Skelet = (
  <Skeleton
    className={cx(styles2.mainSkeletonStyles)}
    variant="rectangular"
    height={"100%"}
    width={"100%"}
  />
);

const VideosThumbnail = ({
  img,
  imgAlt,
  title,
  cat,
  date,
  dark,
  slug,
  duration,
  index,
  viewRef,
}) => {
  const isNewThumInView = useInView(viewRef, { once: true });
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
  }, []);
  return (
    <Link
      href={`/videos/${slug}`}
      style={{
        gap: "0",
        transform: isMounted
          ? isNewThumInView
            ? "none"
            : "translateX(100px)"
          : "none",
        opacity: isMounted ? (isNewThumInView ? 1 : 0) : 1,
        transition: "all ease 1400ms",
        transitionDelay: `${0.1 * index}s`,
      }}
      className={cx(
        styles.container,
        dark && styles.containerDark,
        !dark && styles.containerLight,
        "d-flex",
        "flex-column",
        "align-items-start",
        "justify-content-start"
      )}
    >
      {/*<LazyLoad className="w-100" offset={200}>*/}
      <div
        className={cx(
          styles.imgWrapper,
          "d-flex",
          "align-items-center",
          "w-100",
          "position-relative",
          "justify-content-center",
          "position-relative"
        )}
      >
        {duration && (
          <span
            className={cx(
              styles.videoDurationStyles,
              "d-flex",
              "align-items-center",
              "justify-content-center",
              "position-absolute"
            )}
          >
            {duration?.replace("00:", "")}
          </span>
        )}
        {img ? (
          <Image
            style={{ borderRadius: dark ? "8px 8px 0 0" : "8px" }}
            src={img}
            alt={imgAlt ? imgAlt : title}
            className={cx(styles.imgStyles, "w-100", "h-100")}
            unoptimized={true}
            width="100"
            height="100"
            placeholder="blur"
            loading="lazy"
            blurDataURL={imageBase64}
          />
        ) : (
          Skelet
        )}
      </div>
      {/*</LazyLoad>*/}
      {!dark && (
        <div
          style={{ gap: "0", padding: "20px 0" }}
          className="h-100 d-flex flex-column align-items-start justify-content-start"
        >
          <span
            className={cx("d-lg-flex", "d-none", styles.dateStyles, "mb-2")}
          >
            {cat}
          </span>
          <h2
            // onClick={() => router.push(`/newsroom/${slug}`)}
            className={cx(styles.titleStyles, "mb-auto", styles.tagmargin)}
          >
            {title}
          </h2>
          <div
            className={cx(
              styles.dateContainer,
              "d-none",
              "d-lg-flex",
              "align-items-center",
              "justify-content-start",
              "w-100"
            )}
          >
            <span className={cx(styles.dateStyles)}>{formatedDate(date)}</span>
          </div>
          <div className="d-flex d-lg-none align-items-center justify-content-start">
            <span className={cx(styles.dateStyles)}>{cat}</span>
            <span className={cx(styles.verticalLline)}></span>
            <div
              className={cx(
                styles.dateContainer,
                "d-lg-none",
                "d-flex",
                "align-items-center",
                "justify-content-start",
                "w-100"
              )}
            >
              <span className={cx(styles.dateStyles)}>
                {formatedDate(date)}
              </span>
            </div>
          </div>
        </div>
      )}

      {dark && (
        <div
          style={{ gap: "0", padding: "20px" }}
          className="h-100 w-100 d-flex flex-column align-items-start justify-content-start"
        >
          <span className={cx(styles.dateStyles)}>{cat}</span>
          <h2
            // onClick={() => router.push(`/newsroom/${slug}`)}
            className={cx(
              styles.titleStylesDark,
              "mb-auto",
              styles.marginTop20px
            )}
          >
            {title}
          </h2>
          <div
            className={cx(
              styles.dateContainer,
              "d-flex",
              "align-items-center",
              "justify-content-start",
              "w-100"
            )}
          >
            <span className={cx(styles.dateStyles)}>{formatedDate(date)}</span>
          </div>
        </div>
      )}
    </Link>
  );
};

export default VideosThumbnail;
